import { Controller } from "@hotwired/stimulus"
import '../../_jquery';
import 'slick-carousel/slick/slick.min';
import { isBackend } from '../../utils';

export default class extends Controller {
  static targets = ['slider']

  connect() {
    if (isBackend()) {
      this.#backendInitializer()
    } else {
      this.initialize_slick_carousel(this.sliderTarget)
    }
  }

  disconnect() {
    if (this.clonedTarget) {
      this.clonedTarget.remove()
    }
  }

  initialize_slick_carousel(targetElement) {
    let $that = $(targetElement);

    $that.slick({
      adaptiveHeight: true,
      prevArrow: '<div class="component-testimonials__arrow--prev"></div>',
      nextArrow: '<div class="component-testimonials__arrow--next"></div>',
      arrows: true,
      dots: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            dots: true
          }
        }
      ]
    });
  }

  #backendInitializer() {
    const cloneAndInsert  = () => {
      this.clonedTarget = this.element.cloneNode(true)
      delete this.clonedTarget.dataset['controller']
      this.element.style.display = 'none'
      this.clonedTarget.style.display = 'block'
      this.element.parentElement.appendChild(this.clonedTarget)
    }

    cloneAndInsert()

    let observer = new window.MutationObserver(function (mutations, observer) {
      this.clonedTarget.remove()

      cloneAndInsert()

      this.initialize_slick_carousel(this.clonedTarget.querySelector('.component-testimonials__slider'))
    }.bind(this));
    observer.observe(this.element, { subtree: true, attributes: true, childList: true });

    this.initialize_slick_carousel(this.clonedTarget.querySelector('.component-testimonials__slider'))
  }
}
